import { ref, watch } from "vue"
import useAsclepius from "@common/composables/api/asclepius"
import {
  CompanyYouthMembershipPlan,
  GetActiveCompanyYouthMembershipPlanResponse
} from "@vitable/asclepius-api-client-ts/api"

export function useGetActiveCompanyYouthMembershipPlan() {
  const { getYouthMembershipApi, callWithResponse, callResult } = useAsclepius()
  const activeCompanyYouthMembershipPlan = ref<CompanyYouthMembershipPlan | null>()

  async function getActiveCompanyYouthMembershipPlan(companyId: string): Promise<void> {
    await callWithResponse(() => getYouthMembershipApi().getActiveCompanyYouthMembershipPlan({ companyId }))
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      // @ts-ignore
      const data: GetActiveCompanyYouthMembershipPlanResponse = newValue.getData()
      activeCompanyYouthMembershipPlan.value = data.plan
    }
  })

  return {
    getActiveCompanyYouthMembershipPlan,
    getActiveCompanyYouthMembershipPlanResult: callResult,
    activeCompanyYouthMembershipPlan
  }
}
